;(function () {
  'use strict'

  angular.module('contrast.label').directive('csLabel', [csLabel])

  function csLabel() {
    return {
      templateUrl: 'components/label/cs-label.html',
      replace: true,
      restrict: 'E',
      scope: {
        text: '='
      },
      link: function ($scope, elem, attrs) {
        $scope.rounded = !angular.isUndefined(attrs.rounded)
      }
    }
  }
})()
